import Vue from 'vue'
import moment from 'moment'
import { CefStat, CefStatDetail } from '@/types/ops'
import { KeyDict } from '@/types'

export default Vue.extend({
  methods: {
    subscribeCefHeartbeat (castId) {
      this.$store.direct.dispatch.opsmonitor.subscribeCefHeartbeat(castId)
    },
    unsubscribeCefHeartbeat (castId) {
      this.$store.direct.dispatch.opsmonitor.unsubscribeCefHeartbeat(castId)
    },
    isCefAlive (castId) {
      return this.$store.direct.getters.opsmonitor.isAlive(castId)
    },
    isCefModeAlive (castId, cefMode) {
      return this.$store.direct.getters.opsmonitor.isAlive(castId, cefMode)
    },
    isCefModeInstanceAlive (castId, cefMode, instanceData: CefStatDetail) {
      return this.$store.direct.getters.opsmonitor.isAlive(castId, cefMode, instanceData)
    },
    cefActiveMsg (castId) {
      const stats = this.cefStats(castId)
      if (!stats) {
        return 'No data yet'
      }

      let msg = '<strong>CEF STATUS</strong><br>'
      const modes = ['front', 'back']
      modes.forEach(cefmode => {
        msg += `<br>${cefmode.toUpperCase()}: `

        const instances = this.cefInstances(castId, cefmode)
        const instanceDataList = Object.values(instances)
        if (stats[cefmode] && instanceDataList.length > 0) {
          const isAlive = this.isCefModeAlive(castId, cefmode)
          if (isAlive) {
            msg += 'OK'
          } else {
            msg += '<br>'
            instanceDataList.forEach((instanceData) =>{
              // only show instances that look dead
              const isAlive = this.isCefModeInstanceAlive(castId, cefmode, instanceData)
              if (!isAlive) {
                msg += '<span style="color:#FFCC00">'
                msg += instanceData.key + ': last update @ '
                msg += this.lastUpdatedMsg(castId, cefmode, instanceData)
                msg += '</span>'
              }
            })
          }
        } else {
          msg += 'no data yet'
        }
      })
      return msg
    },
    lastUpdatedMsg (castId: string, cefmode: string, instanceData: CefStatDetail): string {
      const stats = this.cefStats(castId)
      if (!stats || !stats[cefmode] || !instanceData || !instanceData.timestamp) {
        return 'No data yet'
      }

      const now = moment()
      let msg = moment(instanceData.timestamp.seconds * 1000).format('h:mm:ss a')
      const lastSeen = moment(instanceData.timestamp.seconds * 1000)
      msg += '<br>(' + moment.duration(now.diff(lastSeen)).humanize() + ' ago)<br>'
      return msg
    },
    cefInstances (castId: string, cefmode: string): KeyDict<CefStatDetail> {
      const stats = this.cefStats(castId)
      if (!stats || !stats[cefmode] || !stats[cefmode].instances) {
        return {}
      }

      return stats[cefmode].instances
    },
    cefStats (castId: string): CefStat | undefined {
      return this.$store.direct.getters.opsmonitor.cefStats(castId)
    },
    async restartcef (castid) {
      try {
        await this.$confirm(`Are you sure you want to restart cef of this cast?`,
          'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          })
        console.log('Restarting Cef ', castid)
        await this.$store.direct.dispatch.events.restartCef(castid)
      } catch(error) {
        // restartCef does not throw, so this comes from the confirm...
      }
    },
  }
})
